import { render, staticRenderFns } from "./LayHeader.vue?vue&type=template&id=2c23be1e&"
import script from "./LayHeader.vue?vue&type=script&lang=js&"
export * from "./LayHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports